var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yhc-component yhc-fzc-black PrivateLabel label",class:_vm.labelClass},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }